import { Progress } from 'antd';
import IconTip from '@/components/icon-tip';
import React from 'react';

function BaseProcess(props) {
  const { title, tipTitle, processWidth, strokeColor, attrs } = props;
  return (
    <div className="report-process-item">
      <div className="report-process-item-font">
        {title}
        <IconTip title={tipTitle} size="small" type="info" />
      </div>
      <div style={{ width: processWidth }}>
        <Progress strokeColor={strokeColor} trailColor="#E8E8E8" {...attrs} />
      </div>
    </div>
  );
}
export default BaseProcess;
